import ReactPixel from 'react-facebook-pixel'

export const initFBPixel = (): void => {
  if (import.meta.env.VITE_APP_BUILD_ENV === 'production' && import.meta.env.VITE_APP_FB_PIXEL_ID) {
    const options = {
      autoConfig: true,
      debug: true,
    }
    ReactPixel.init(import.meta.env.VITE_APP_FB_PIXEL_ID, undefined, options)
    ReactPixel.grantConsent()
  }
}

export const removeFBPixel = () => {
  ReactPixel.revokeConsent()
}
